<section>
  <h1 class="my-3">Merge Agencies</h1>
  <p class="required-field">Select an agency from the list to keep. It will gain the ORI number(s) of the other.</p>
  <p-messages key="oriMergeMessage" [closable]="true"></p-messages>
  <p-table #agencydt [value]="selectedAgencies" [columns]="cols" dataKey="AgencyID" responsiveLayout="scroll" selectionMode="single" [(selection)]="parentAgency">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
      <tr [pSelectableRow]="rowData">
        <td>
          {{rowData.AgencyName}}
        </td>
        <td>
          <div>
            <div>
              <ng-container *ngFor="let oriNum of rowData.ENESS_XREF_AgencyOriNum; let i=index; let last=last; let first=first">
                <div>{{rowData.ENESS_XREF_AgencyOriNum[i].OriNum}}</div>
              </ng-container>
            </div>
          </div>
        </td>
        <td>
          {{rowData.FieldDivisionName}}
        </td>
        <td>
          <ng-container *ngFor="let group of rowData.ENESS_XREF_AgencyFieldDivisionGroups; let i=index;let last=last; let first=first;">
            <div>{{ rowData.ENESS_XREF_AgencyFieldDivisionGroups[i].GroupName }}</div>
          </ng-container>
        </td>
        <td>
          {{rowData.StateName}}
        </td>
        <td>
          {{rowData.CountyName}}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div>
    <button type="button" class="btn btn-active m-3" [disabled]="!parentAgency" (click)="mergeAgencies()">Confirm Agency ORI Merge</button>
    <button type="button" (click)="closeForm()" class="btn btn-active mx-3">Close</button>
  </div>
</section>
